import { render, staticRenderFns } from "./ClassBox.vue?vue&type=template&id=ad976d68&scoped=true&"
import script from "./ClassBox.vue?vue&type=script&lang=js&"
export * from "./ClassBox.vue?vue&type=script&lang=js&"
import style0 from "./ClassBox.vue?vue&type=style&index=0&id=ad976d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad976d68",
  null
  
)

export default component.exports